import Box from '@material-ui/core/Box';
import { ROLES } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { hasRestrictedRole, hasValue } from 'globalutils/fmUtils';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import TopActions from './TopActions';
import { columns, formattedType } from './config';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));

const WorkOrderComponent = ({
  theme,
  apiStatus,
  callback,
  history,
  Styled,
  fetchInspections,
  bulkDownloadReport,
  inspections,
  list,
  changeRequest,
  isAdvancedDviRequired,
  isCustomDviRequired,
  clearApiStatus,
  i18n,
  topAction,
  filters,
  viewReport,
  request,
  pagination,
  setPagination,
  needSort,
}) => {
  const hasApiStatus = hasValue(apiStatus.status, 'api', fetchInspections);
  const information =
    hasApiStatus && hasApiStatus.errorMessage ? (
      <Message type="error" s message={i18n.t(hasApiStatus.errorMessage)} />
    ) : (
      i18n.t('common.tableEmptyMessage')
    );
  const isServiceManager = hasRestrictedRole([ROLES.SERVICE_MANAGER, ROLES.MECHANIC]);

  if (isServiceManager) {
    columns.splice(4, 1);
  }

  const generateRows = () => {
    const updatedList = inspections?.content?.map((item) => {
      let result = { ...item };
      result.type = formattedType[item.type] || '-';
      result.work_order_id = hasRestrictedRole([ROLES.DRIVER]) ? (
        item.work_order_id
      ) : (
        <Link href={`/inspections/edit/${item.work_order_id}`}>{item.work_order_id}</Link>
      );
      let vinTrimmedValue = result?.unit_id?.name;
      if (result?.unit_id?.name) {
        vinTrimmedValue = result.unit_id.name.substr(result?.unit_id?.name.length - 8);
        vinTrimmedValue = `...${vinTrimmedValue}`;
      }
      result.unitId = (
        <Link href={`/${item.unitType === 'TRAILER' ? 'trailer' : 'vehicle'}/edit/${item.unit_id?.id}`}>{vinTrimmedValue}</Link>
      );
      if (hasRestrictedRole([ROLES.SERVICE_MANAGER, ROLES.DRIVER, ROLES.MECHANIC])) {
        result.unitId = vinTrimmedValue;
      }
      result.mechanicName = <Link href={`/user/edit/${item.mechanic?.id}`}>{item.mechanicName}</Link>;
      if (!item.mechanic?.isSameCompany || hasRestrictedRole([ROLES.DRIVER, ROLES.MECHANIC])) {
        result.mechanicName = item.mechanicName;
      }
      result.driverName = hasRestrictedRole([ROLES.SERVICE_MANAGER, ROLES.DRIVER, ROLES.MECHANIC]) ? (
        item.driverName
      ) : (
        <Link href={`/user/edit/${item.driver?.id}`}>{item.driverName}</Link>
      );
      result.report = item.inspection_report?.id ? (
        <Icon
          src={mediaUrls?.viewReports}
          tableicon
          onClick={() =>
            viewReport({
              apiId: 'viewReportApi',
              data: item?.inspection_report?.id,
            })
          }
          tooltip={i18n.t('workOrders.viewReport')}
        ></Icon>
      ) : (
        <div className="noPointer">
          <Icon src={mediaUrls?.viewReports} tableicon></Icon>
        </div>
      );
      result.status = item.status?.name;
      const isOverDue =
        !['Approved', 'Completed'].includes(item.status?.name) &&
        item.due_date &&
        moment(new Date(item.due_date)).unix() < moment(new Date()).unix();
      result.overDue = isOverDue ? <span className="overdue-flag">OVERDUE</span> : null;
      result.id = item.work_order_id;
      return result;
    });
    return updatedList || [];
  };

  return (
    <Box style={{ ...theme.palette.contentStyle, overflowX: 'hidden' }}>
      <Styled.Wrapper>
        {topAction && (
          <TopActions
            {...{
              isAdvancedDviRequired,
              isCustomDviRequired,
              i18n,
              history,
              list,
              bulkDownloadReport,
              apiStatus,
              clearApiStatus,
              callback,
              Styled,
              changeRequest,
              hasApiStatus,
              filters,
              request,
              pagination,
              setPagination,
            }}
          />
        )}
        <div className="quickFilter"></div>
        <Styled.TableWrapper>
          <div className="driverstatusTitle">
            <span className="spireonOldOnly">Inspections</span>
          </div>
          <Table
            type="server"
            defaultSortBy={needSort ? { sortBy: 'type', order: 'desc' } : null}
            changeRequest={changeRequest}
            baseRequest={request}
            title=""
            columns={[...columns]}
            data={generateRows()}
            emptyMessage={information}
            itemsPerPage={checkServiceProvider('components_itemsPerPage', window.$environment.SERVICE_PROVIDER, false)}
            totalRecords={inspections?.totalElements}
            actions={[]}
            i18n={i18n}
            pageinationReset={pagination}
            pagenationClicked={(e) => {
              setPagination(!e);
            }}
            columnAlign={'left'}
          />
        </Styled.TableWrapper>
      </Styled.Wrapper>
    </Box>
  );
};

WorkOrderComponent.propTypes = {
  history: PropTypes.object.isRequired,
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  fetchViolations: PropTypes.func.isRequired,
  handleExportCsaViolations: PropTypes.func.isRequired,
};

export default WorkOrderComponent;
